import axios from "axios";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import styled from "styled-components";

const Titulo = styled.h3`
    margin: 5px auto;
    text-align: center;
    color: #7d0000;
    font-size: 15px;
`

const SubTitulo = styled.h4`
    margin: 3px auto;
    text-align: center;
    color:rgb(160, 0, 0);
    font-size: 13px;
`

const ContainerBotoes = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    margin-top: 20px;
`

const BotaoConfirmar = styled.button`
    width: calc( 50% - 5px );
    height: 35px;
    background-color: #DC2625;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    font-weight: bold;
    transition: .3s;
    &:hover {
        background-color: #B91C1C;
        scale: 1.05;
    }
`

const BotaoCancelar = styled.button`
    width: calc( 50% - 5px );
    height: 35px;
    background-color: #fff;
    color: black;
    border: 2px solid #ccc;
    cursor: pointer;
    border-radius: 5px;
    font-weight: bold;
    transition: .3s;
    &:hover {
        background-color: #f0f0f0;
        border-color: #aaa;
        scale: 1.05;
    }
`

const ModalDeleteConteudo = ({ id, onClose, onSuccess }) => {

    const { closeModal } = useModal();

    const handleDelete = async () => {

        try {

            const formData = new FormData();
            formData.append("id", id);

            const url = "https://sistemaintegrado.palmont.com.br/Painel/API/Treinamentos/DeleteConteudo/";
            const { data } = await axios.post(url, formData, { withCredentials: true });
            console.log(data);

            await onSuccess();
            onClose();

        } catch (error) {

            console.error("Erro ao deletar conteúdo:", error);
            alert("Erro ao deletar conteúdo. Tente novamente.");

        }

    }

    return(
        <Overlay state={ true } >
            <Modal close={ closeModal } header={ false } size="sm" >
                <Titulo>DELETAR CONTEÚDO</Titulo>
                <SubTitulo>Todos os subitens também serão removidos.</SubTitulo>
                <ContainerBotoes>
                    <BotaoCancelar onClick={ closeModal } >CANCELAR</BotaoCancelar>
                    <BotaoConfirmar onClick={ handleDelete }>APAGAR</BotaoConfirmar>
                </ContainerBotoes>
            </Modal>
        </Overlay>
    )

}

export default ModalDeleteConteudo;